import { render, staticRenderFns } from "./VTextArea.vue?vue&type=template&id=696afb88&scoped=true"
import script from "./VTextArea.vue?vue&type=script&lang=js"
export * from "./VTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696afb88",
  null
  
)

export default component.exports